import InfoPanel from '@components/primitives/InfoPanel'
import { Text } from '@components/primitives/Text'
import type { TrialOverrides } from '@modules/trials/types/TrialOverrides'

export const SiteInfoPanel = ({
  overrides,
}: {
  overrides: TrialOverrides | null
}) => {
  if (!overrides?.siteInfo) {
    return null
  }

  const { siteInfo } = overrides

  const values = [
    <>
      <Text
        className='text-neutral500'
        key={`info-panel-${siteInfo.protocolNumber}-site-name-title`}
        styleName='p-xxtiny'
        value='Site Name'
      />
      <Text
        className='text-neutral700'
        key={`info-panel-${siteInfo.protocolNumber}-site-name`}
        styleName='p-tiny'
        value={`${siteInfo.siteName}`}
      />
    </>,
    <>
      <Text
        className='text-neutral500'
        key={`info-panel-${siteInfo.protocolNumber}-protocol-number-title`}
        styleName='p-xxtiny'
        value='JH IRB Protocol Number'
      />
      <Text
        className='text-neutral700'
        key={`info-panel-${siteInfo.protocolNumber}-protocol-number`}
        styleName='p-tiny'
        value={siteInfo.protocolNumber}
      />
    </>,
    <>
      <Text
        className='text-neutral500'
        key={`info-panel-${siteInfo.protocolNumber}-principal-investigator-title`}
        styleName='p-xxtiny'
        value='Principal Investigator'
      />
      <Text
        className='text-neutral700'
        key={`info-panel-${siteInfo.protocolNumber}-principal-investigator`}
        styleName='p-tiny'
        value={siteInfo.principalInvestigator}
      />
    </>,
  ]

  return <InfoPanel values={values} />
}
